import {
  initialState,
  Actions,
  State,
  EDIT_PREJUDICIAL,
  EDIT_PREJUDICIAL_SUCCESS,
  EDIT_PREJUDICIAL_ERROR,
  RESET_EDIT_PREJUDICIAL,
} from "../../types/prejudicial/edit";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_PREJUDICIAL:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case EDIT_PREJUDICIAL_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case EDIT_PREJUDICIAL_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_EDIT_PREJUDICIAL:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
